import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import {  
  API_CREATE_SUB_DEPARTMENT,
  API_DELETE_SUB_DEPARTMENT,
  API_GET_SUB_DEPARTMENT_LIST,
  API_GET_SUBDEPARTMENTS_BY_DEPARTMENT,
  API_UPDATE_SUB_DEPARTMENT,
} from "../../../shared/routes/private.routes";

const config = {
  name: "sub-department",
};

export const getSubDepartmentList: any = createAsyncThunk(
  `${config.name}/getSubDepartmentList`,
  async ({ params, body }: any) => {
    return Client.post(API_GET_SUB_DEPARTMENT_LIST, body, { params });
  }
);

export const createSubDepartment: any = createAsyncThunk(
  `${config.name}/create-sub-departments`,
  async (body: any) => {
    return Client.post(API_CREATE_SUB_DEPARTMENT, body);
  }
);

export const deleteSubDepartment: any = createAsyncThunk(
  `${config.name}/delete-sub-department`,
  async (subDepartmentId: string) => {
    return Client.delete(API_DELETE_SUB_DEPARTMENT + `${subDepartmentId}`);
  }
);


export const getSubDepartmentsByDepartment: any = createAsyncThunk(
  `${config.name}/get-sub-departments-by-department`,
  async (departmentId: string) => {
    const result = await Client.get(API_GET_SUBDEPARTMENTS_BY_DEPARTMENT + `${departmentId}`);
    return result?.data;
  }
);

export const updateSubDepartmentById: any = createAsyncThunk(
  `${config.name}/update-sub-department`,
  async ({ subDepartmentId, body }: { subDepartmentId: string; body: any }) => {
    const url = API_UPDATE_SUB_DEPARTMENT + `${subDepartmentId}`;
    return Client.put(url, body);
  }
);

export const subDepartmentReducer = createSlice({
  name: config.name,
  initialState: {
    loadingSubDepartment: false as any,
    subDepartmentList: [] as any,
    filters: {} as any,
    pagination: { page: 0, limit: TABLE_ROWS_COUNT, total: 0 },
  },
  reducers: {
    resetSubDepartment: (state) => {
      state.loadingSubDepartment = false;
      state.subDepartmentList = [];
      state.filters = {};
      state.pagination = { page: 0, limit: TABLE_ROWS_COUNT, total: 0 };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getSubDepartmentList.pending, (state) => {
        state.loadingSubDepartment = true;
        state.subDepartmentList = [] as any;
      })
      .addCase(getSubDepartmentList.fulfilled, (state, action) => {
        state.loadingSubDepartment = false;
        state.subDepartmentList = action?.payload?.data?.data as any;
        state.pagination = {
          page: action?.payload?.data?.page,
          limit: action?.payload?.data?.limit,
          total: action?.payload?.data?.total,
        };
      })
      .addCase(getSubDepartmentList.rejected, (state) => {
        state.loadingSubDepartment = false;
        state.subDepartmentList = [] as any;
      });
  },
});

export const { resetSubDepartment } = subDepartmentReducer.actions;
export default subDepartmentReducer.reducer;
